<template>
  <div class="main">
    <c-panel>
      <dashboard></dashboard>
    </c-panel>
  </div>
</template>

<script>
import dashboard from "./dashboard"

export default {
  components: { dashboard }
}
</script>

